<template>
  <Team_manager_adviser_bar_en_m></Team_manager_adviser_bar_en_m>
  <router-view></router-view>
</template>

<script>
import Team_manager_adviser_bar_en_m from "@/components/EN_mobile/team/Team_manager_adviser_bar_en_m";
export default {
  name: 'Team_manager_adviser_en_m',
  components: {Team_manager_adviser_bar_en_m, }
}

</script>

<style scoped>

</style>